/**
 * localStorage/sessionStorage keys for the plan-change notice.
 *
 * Mirrors the deploy-version pattern (`update-notification-keys.ts`): the app
 * snapshots the plan tier it last showed; when the admin (or the backend)
 * changes app_metadata, the client detects the diff, asks to refresh, and
 * shows a one-time confirmation after the reload.
 */

/** localStorage snapshot of the last seen plan tier (from `/api/auth/me`). */
export const PLAN_SNAPSHOT_KEY = "vortixy_plan_snapshot";

/** sessionStorage flag with the new plan, set right before reload so the post-refresh notice appears once. */
export const PLAN_CHANGED_NOTICE_KEY = "vortixy_plan_changed_notice";
